export enum EVENT_ANALYTIC {
  // Page View
  GEMX_VIEW_DASHBOARD = 'GEMX_VIEW_DASHBOARD',
  GEMX_VIEW_DASHBOARD_WELCOME = 'GEMX_VIEW_DASHBOARD_WELCOME',
  GEMX_VIEW_ANALYTICS = 'GEMX_VIEW_ANALYTICS',
  GEMX_VIEW_ANALYTICS_LIST = 'GEMX_VIEW_ANALYTICS_LIST',
  GEMX_VIEW_ANALYTICS_PAGE_DETAIL = 'GEMX_VIEW_ANALYTICS_PAGE_DETAIL',
  GEMX_VIEW_DETAIL = 'GEMX_VIEW_DETAIL',
  GEMX_VIEW_CAMPAIGN_LIST = 'GEMX_VIEW_CAMPAIGN_LIST',
  GEMX_VIEW_CAMPAIGN_NEW = 'GEMX_VIEW_CAMPAIGN_NEW',
  GEMX_VIEW_PLAN = 'GEMX_VIEW_PLAN',
  GEMX_VIEW_PLAN_EXPIRED = 'GEMX_VIEW_PLAN_EXPIRED',

  // Campaign
  GEMX_CAMPAIGN_STATUS = 'GEMX_CAMPAIGN_STATUS',
  GEMX_CAMPAIGN_UPDATE = 'GEMX_CAMPAIGN_UPDATE',
  GEMX_CAMPAIGN_CREATE = 'GEMX_CAMPAIGN_CREATE',
  GEMX_CAMPAIGN_DELETE = 'GEMX_CAMPAIGN_DELETE',
  GEMX_CAMPAIGN_TEMPLATE_COPY_LINK = 'GEMX_CAMPAIGN_TEMPLATE_COPY_LINK',
  GEMX_CAMPAIGN_TEMPLATE_PREVIEW = 'GEMX_CAMPAIGN_TEMPLATE_PREVIEW',

  // Analytics
  GEMX_OPEN_CHANGE_LAYOUT = 'GEMX_OPEN_CHANGE_LAYOUT',
  GEMX_CHANGE_CURRENCY_MODE = 'GEMX_CHANGE_CURRENCY_MODE',
  GEMX_CHANGE_TRACKING_MODE = 'GEMX_CHANGE_TRACKING_MODE',
  GEMX_CHANGE_LAYOUT = 'GEMX_CHANGE_LAYOUT',

  // Plan
  GEMX_CHANGE_CAPPED_AMOUNT = 'GEMX_CHANGE_CAPPED_AMOUNT',
  GEMX_RETRY_PAYMENT = 'GEMX_RETRY_PAYMENT',
  GEMX_CHOOSE_PLAN = 'GEMX_CHOOSE_PLAN',
  GEMX_CANCEL_PLAN = 'GEMX_CANCEL_PLAN',

  // Web Vitals
  WEB_VITALS = 'web_vitals',

  // Preview & Copy Link Features
  GEMX_MODAL_PREVIEW_CAMPAIGN = 'GEMX_MODAL_PREVIEW_CAMPAIGN',
  GEMX_MODAL_COPY_LIVE_PAGE = 'GEMX_MODAL_COPY_LIVE_PAGE',

  // Page Analytics Demo
  GEMX_ANALYTICS_DEMO_VIEW = 'GEMX_ANALYTICS_DEMO_VIEW',
  GEMX_ANALYTICS_DEMO_IDEA_VIEW_DETAIL = 'GEMX_ANALYTICS_DEMO_IDEA_VIEW_DETAIL',
  GEMX_ANALYTICS_DEMO_IDEAS_SIDEBAR_CLOSE = 'GEMX_ANALYTICS_DEMO_IDEAS_SIDEBAR_CLOSE',

  // Demo Event
  DEMO_EVENT = 'DEMO_EVENT',
}
